import { Component } from "react";
import { connect } from "react-redux";
import { Popover } from "antd";
import { withRouter } from "util/withRouter";
import noAvatar from "assets/images/no-avatar.webp"
import Auxiliary from "util/Auxiliary";
import Avatar from "components/Avatar";
import IntlMessages from "util/IntlMessages";
import { APPLICATION_PATHS } from "constants/ApplicationPaths";

import {
  signOutAction
} from "appRedux/actions/Auth";

import {
  USER_ROLE_COMEDIEN,
  USER_ROLE_UTILISATEUR,
  USER_ROLE_ADMIN,
} from "../../constants/General";

class UserProfile extends Component {
  constructor() {
    super();
    this.state = {
      showPopover: false,
    }
  }

  handleVisiblePopoverChange = showPopover => {
    this.setState({ showPopover });
  };

  signOut = () => {
    this.props.signOutAction();
  };

  redirectToCompte = () => {
    const { currentUser } = this.props;

    this.setState({
      showPopover: false,
    });

    if (currentUser) {
      switch (currentUser.typeCompte) {
        case USER_ROLE_UTILISATEUR:
          window.location.replace(APPLICATION_PATHS.HOME_UTILISATEUR);
          break;
        case USER_ROLE_COMEDIEN:
          window.location.replace(APPLICATION_PATHS.COMEDIEN.MON_PROFIL);
          break;
        case USER_ROLE_ADMIN:
          window.location.replace(APPLICATION_PATHS.HOME_ADMIN);
          break;
        default:
          window.location.replace(APPLICATION_PATHS.HOME);
      }
    }
  };

  render() {
    const { currentUser } = this.props;

    const userMenuOptions = (
      <ul className="gx-user-popover cm-top-bar-popover">
        <li>
          <a href={APPLICATION_PATHS.AIDE}>
            <IntlMessages id="topBar.userProfile.popover.aide" />
          </a>
        </li>
        <li onClick={this.redirectToCompte}>
          <IntlMessages id="topBar.userProfile.popover.compte" />
        </li>
        <li onClick={this.signOut}>
          <IntlMessages id="topBar.userProfile.popover.deconnexion" />
        </li>
      </ul>
    );

    var avatarSrc;
    if (currentUser && currentUser.photo) {
      avatarSrc = currentUser.photo;
    } else {
      avatarSrc = noAvatar;
    }

    return (
      <Auxiliary>
        <Popover
          placement="bottomRight"
          content={userMenuOptions}
          trigger="click"
          visible={this.state.showPopover}
          onVisibleChange={this.handleVisiblePopoverChange}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <div>
              <Avatar
                src={avatarSrc}
                width="30px"
                height="30px"
                style={{ cursor: "pointer", marginRight: "8px" }}
              />
            </div>
            <div className="cm-top-bar-col-avatar-text">
              {currentUser ?
                <Auxiliary>
                  <IntlMessages id="topBar.userProfile.bonjour" /><br />
                  {currentUser.prenom}
                </Auxiliary>
                : null}
            </div>
          </div>
        </Popover>
      </Auxiliary>
    )
  }
}

const mapStateToProps = ({ auth }) => {
  const {
    currentUser
  } = auth;

  return {
    currentUser
  }
};

export default withRouter(
  connect(
    mapStateToProps,
    {
      signOutAction

    }
  )(UserProfile)
);